import {useSearchParams} from 'react-router-dom';

const useQueryParams = () => {
    const [searchParams, setSearchParams] = useSearchParams();

    const setQueryParam = (key: string, value: string | number) => {
        searchParams.set(key, String(value));
        setSearchParams(searchParams);
    };

    const removeQueryParam = (key: string) => {
        searchParams.delete(key);
        setSearchParams(searchParams);
    };

    const getQueryParam = (key: string) => {
        return searchParams.get(key);
    };

    return {
        setQueryParam,
        removeQueryParam,
        getQueryParam,
        searchParams,
    };
};

export default useQueryParams;
